import { useContext, useEffect, useState } from 'react';
import { Button, Col, Container, Row } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { useNavigate } from 'react-router-dom';
import { SessionContext } from '../../../app/contexts/SessionContext';
import { useDocumentTitle } from '../../../app/hooks/use-document-title';
import { InviteUserDialog } from '../InviteUserDialog';
import { UsersList } from './UsersList';

export const HealthcareEntityUsersList = () => {
  useDocumentTitle('Users list');
  const [showInviteDialog, setShowInviteDialog] = useState(false);
  const { user } = useContext(SessionContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user?.group_names?.includes('manage_users')) {
      navigate('/');
    }
  }, [user]);

  return (
    <>
      <div className="bg-primary-dark">
        <Container className="page-header-title">
          <div className="d-flex justify-content-between align-items-center">
            <h1 className="mb-3">Team</h1>
            <div>
              <LinkContainer to="/app/healthcare-entity/pending-invitations">
                <Button variant="primary" className="me-2">
                  Pending Invitations
                </Button>
              </LinkContainer>
              <Button variant="primary" size="md" onClick={() => setShowInviteDialog(true)}>
                Invite User
              </Button>
              <InviteUserDialog
                show={showInviteDialog}
                onClose={() => setShowInviteDialog(false)}
              />
            </div>
          </div>
        </Container>
      </div>
      <div style={{ position: 'relative' }}>
        <div
          className="bg-primary-dark d-block"
          style={{
            height: '120px',
            position: 'absolute',
            left: 0,
            right: 0,
            top: 0,
            zIndex: -10,
          }}
        />
        <Container style={{ position: 'relative' }}>
          <Row className="justify-content-center" xs={12}>
            <Col>
              <UsersList />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
